module.exports = __webpack_public_path__ + "static/media/service.199a573f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/service.png
// module id = 573
// module chunks = 0